import firebase from 'firebase/app';
import 'firebase/firestore';

const config = {
  apiKey: 'AIzaSyCMZYq1m5wVwrQ3K1LTnwcBsjNKM3jliMA',
  authDomain: 'errand-list.firebaseapp.com',
  databaseURL: 'https://errand-list.firebaseio.com',
  projectId: 'errand-list',
  storageBucket: 'errand-list.appspot.com',
  messagingSenderId: '273925028132'
};

const Firebase = firebase.initializeApp(config);

const db = firebase.firestore();

db.enablePersistence().catch(({ code, message }) => {
  if (code === 'failed-precondition') {
    console.log(message);
  } else if (code === 'unimplemented') {
    console.log(message);
  }
});

export default Firebase;
